export default __webpack_public_path__ + "static/media/img9.8fd017e4.PNG";